import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=6f25220d&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=6f25220d&prod&lang=scss"
import style1 from "./Table.vue?vue&type=style&index=1&id=6f25220d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25220d",
  null
  
)

export default component.exports